import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@heroui/react';
import type { Cliente } from '@/types/cliente.model';

interface ClienteDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  cliente?: Cliente;
}

const ClienteDetailModal = ({ isOpen, onClose, cliente }: ClienteDetailModalProps) => {
  if (!cliente) {
    return null;
  }

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      placement="top-center"
      backdrop="blur"
      size="2xl"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1 text-xl font-bold">
              Detalle del Cliente
            </ModalHeader>
            <ModalBody className="space-y-4 py-4">
              <div className="rounded-xl p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Left column */}
                  <div className="space-y-4">
                    <div className="rounded-lg p-4">
                      <h3 className="text-sm font-semibold uppercase tracking-wider mb-2">Información Principal</h3>
                      <div className="space-y-3">
                        <div>
                          <p className="text-xs">Nombre</p>
                          <p className="font-medium">{cliente.nombre || '-'}</p>
                        </div>
                        <div>
                          <p className="text-xs">Razón Social</p>
                          <p className="font-medium">{cliente.razonSocial || '-'}</p>
                        </div>
                        <div>
                          <p className="text-xs">Tipo de Identificación</p>
                          <p className="font-medium">{cliente.tipoIdentificacion || '-'}</p>
                        </div>
                        <div>
                          <p className="text-xs">Número de Identificación</p>
                          <p className="font-medium">{cliente.numeroIdentificacion || '-'}</p>
                        </div>
                      </div>
                    </div>
                    
                    <div className="rounded-lg p-4">
                      <h3 className="text-sm font-semibold uppercase tracking-wider mb-2">Contacto</h3>
                      <div className="space-y-3">
                        <div>
                          <p className="text-xs">Email</p>
                          <p className="font-medium">{cliente.email || '-'}</p>
                        </div>
                        <div>
                          <p className="text-xs">Teléfono</p>
                          <p className="font-medium">{cliente.telefono || '-'}</p>
                        </div>
                        <div>
                          <p className="text-xs">Dirección</p>
                          <p className="font-medium">{cliente.direccion || '-'}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Right column */}
                  <div className="space-y-4">
                    <div className="rounded-lg p-4">
                      <h3 className="text-sm font-semibold uppercase tracking-wider mb-2">Contacto Adicional</h3>
                      <div className="space-y-3">
                        <div>
                          <p className="text-xs">Persona de Contacto</p>
                          <p className="font-medium">{cliente.personaContacto || '-'}</p>
                        </div>
                        <div>
                          <p className="text-xs">Email de Contacto</p>
                          <p className="font-medium">{cliente.emailContacto || '-'}</p>
                        </div>
                        <div>
                          <p className="text-xs">Teléfono de Contacto</p>
                          <p className="font-medium">{cliente.telefonoContacto || '-'}</p>
                        </div>
                      </div>
                    </div>
                    
                    <div className="rounded-lg p-4">
                      <h3 className="text-sm font-semibold uppercase tracking-wider mb-2">Información del Sistema</h3>
                      <div className="space-y-3">
                        <div>
                          <p className="text-xs">ID</p>
                          <p className="font-medium">{cliente.id || '-'}</p>
                        </div>
                        <div>
                          <p className="text-xs">Document ID</p>
                          <p className="font-medium">{cliente.documentId || '-'}</p>
                        </div>
                        <div>
                          <p className="text-xs">Fecha de Creación</p>
                          <p className="font-medium">{cliente.createdAt ? new Date(cliente.createdAt).toLocaleDateString() : '-'}</p>
                        </div>
                        <div>
                          <p className="text-xs">Fecha de Actualización</p>
                          <p className="font-medium">{cliente.updatedAt ? new Date(cliente.updatedAt).toLocaleDateString() : '-'}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button 
                color="primary" 
                variant="light"
                onPress={onClose}
              >
                Cerrar
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default ClienteDetailModal;